import React, { Component } from 'react'
import { Button, Input } from 'antd'
import EstimateItem from './EstimateItem'
import { handleItemCalcs } from '../../util'
import numeral from 'numeral'

const ButtonGroup = Button.Group

class EstimateSection extends Component {
  calculateSectionSubTotal = () => {
    const { section } = this.props
    let total = 0
    if (!section.markedForDeletion && section.items && section.items.length > 0) {
      for (const item of section.items) {
        if (!item.markedForDeletion) {
          total += item.quantity * item.cost
        }
      }
    }
    return numeral(total).format('$0,0.00')
  }

  calculateSectionTotal = () => {
    const { section } = this.props
    let total = 0
    if (!section.markedForDeletion && section.items && section.items.length > 0) {
      for (const item of section.items) {
        if (!item.markedForDeletion) {
          const calculatedItem = handleItemCalcs(item)
          total += calculatedItem.grand_total
        }
      }
    }
    return numeral(total).format('$0,0.00')
  }

  render() {
    const {
      section,
      sectionIndex,
      handleItemChange,
      handleItemColumnChange,
      handleSectionDown,
      handleSectionUp,
      handleSectionDelete,
      handleItemDown,
      handleItemUp,
      handleAddItem,
      handleItemDelete,
      handleSectionNameChange,
      handleDuplicateSection
    } = this.props
    return (
      <table className="table table-bordered">
        <thead className="table-primary">
          <tr>
            <th scope="col">
              <Input
                name="sectionNName"
                value={section.name}
                onChange={event => handleSectionNameChange(event, sectionIndex)}
                style={{ width: '25%' }}
              />
            </th>
            <th scope="col" className="text-right">
              {' '}
              <ButtonGroup>
                <Button onClick={() => handleDuplicateSection(sectionIndex)}>Duplicate</Button>
                <Button type="normal" onClick={() => handleSectionDown(sectionIndex)} icon="down" />
                <Button type="normal" onClick={() => handleSectionUp(sectionIndex)} icon="up" />
                <Button
                  type="danger"
                  onClick={() => handleSectionDelete(sectionIndex)}
                  icon="delete"
                />
              </ButtonGroup>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {section.items &&
              section.items.length > 0 && (
                <th scope="row" colSpan={2}>
                  <table className="table table-hover">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Qty</th>
                        <th scope="col">Cost</th>
                        <th scope="col" className="text-nowrap">
                          Sub-Total
                        </th>
                        <th scope="col">OH</th>
                        <th scope="col">MU</th>
                        <th scope="col">Tax</th>
                        <th scope="col">Total</th>
                        <th scope="col">&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {section.items.map((item, index) => {
                        return (
                          !item.markedForDeletion && (
                            <EstimateItem
                              key={index}
                              item={{ ...item }}
                              itemIndex={index}
                              sectionIndex={sectionIndex}
                              handleItemChange={handleItemChange}
                              handleItemUp={handleItemUp}
                              handleItemDown={handleItemDown}
                              handleItemColumnChange={handleItemColumnChange}
                              handleItemDelete={handleItemDelete}
                              defaultOverhead={this.props.defaultOverhead}
                              defaultTax={this.props.defaultTax}
                              defaultMarkup={this.props.defaultMarkup}
                            />
                          )
                        )
                      })}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={4}>Totals:</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{this.calculateSectionSubTotal()}</td>
                        <td colSpan={3}>&nbsp;</td>
                        <td style={{ whiteSpace: 'nowrap' }}>{this.calculateSectionTotal()}</td>
                        <td>&nbsp;</td>
                      </tr>
                    </tfoot>
                  </table>
                </th>
              )}
            {!section.items ||
              (section.items.length === 0 && (
                <th scope="row" colSpan={2}>
                  <div className="alert alert-primary" role="alert">
                    No items yet
                  </div>
                </th>
              ))}
          </tr>
          <tr>
            <td colSpan={2}>
              <Button onClick={() => handleAddItem(sectionIndex)}>Add Item</Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default EstimateSection



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateSection.js